import SynchronousRegistry from './SynchronousRegistry';
import SynchronousMetaRegistry from './SynchronousMetaRegistry';

export {
    SynchronousRegistry,
    SynchronousMetaRegistry
};
